module.exports = __webpack_public_path__ + "img/CarPal.46792b9a.png";